import { appendURLParams } from '@shm-open/utilities';

const Event = {
    CHANGE: 'change',
    SELECTED: 'selected',
};

const getorcreatePool = (cls) => {
    if (!cls)
        return null;
    let pool;
    if (Object.prototype.hasOwnProperty.call(cls, '_$pool')) {
        pool = cls._$pool;
    }
    else {
        pool = [];
        Object.defineProperty(cls, '_$pool', {
            value: pool,
        });
    }
    return pool;
};
const get = (Cls, params) => {
    const pool = getorcreatePool(Cls);
    const inst = pool.length ? pool.pop() : new Cls();
    if (params) {
        Object.keys(params).forEach((key) => {
            inst[key] = params[key];
        });
    }
    return inst;
};
const recycle = (inst) => {
    const cls = inst.constructor;
    if (cls) {
        const pool = getorcreatePool(cls);
        if (pool) {
            pool.push(inst);
        }
    }
};
const ObjectPool = {
    get,
    recycle,
};

class Handler {
    static create(caller, method, args, once = true) {
        return ObjectPool.get(Handler).setTo(caller, method, args, once);
    }
    setTo(caller, method, args, once = true) {
        this._id = Handler._$globalID++;
        this._method = method;
        this._caller = caller;
        this._args = args;
        this._once = once;
        return this;
    }
    run() {
        this.runWith();
    }
    runWith(...appendArgs) {
        // eslint-disable-next-line no-nested-ternary
        const args = appendArgs
            ? this._args
                ? this._args.concat(appendArgs)
                : appendArgs
            : this._args
                ? this._args.concat()
                : null;
        this._method.apply(this._caller, args);
        if (this._once) {
            this.recycle();
        }
        if (args) {
            args.length = 0;
            args.length = 0;
        }
    }
    recycle() {
        if (this._id === 0)
            return;
        this._method = null;
        this._caller = null;
        this._args = null;
        this._id = 0;
        this._once = false;
        ObjectPool.recycle(this);
    }
    /**
     * 比较两个Handler的函数体是否相同
     */
    compare(caller, func) {
        return this._method === func && this._caller === caller;
    }
    get once() {
        return this._once;
    }
    get isRecycle() {
        return this._id === 0;
    }
    get caller() {
        return this._caller;
    }
    get method() {
        return this._method;
    }
}
Handler._$globalID = 0;

class EventDispatcher {
    constructor() {
        this._eventDic = {};
    }
    addListener(type, caller, listener) {
        if (!type || listener == null)
            return;
        const all = this._eventDic[type];
        if (!all) {
            this._eventDic[type] = [Handler.create(caller, listener, null, false)];
            return;
        }
        const alreadyHas = all.some((item) => item.compare(caller, listener));
        if (!alreadyHas) {
            all.push(Handler.create(caller, listener, null, false));
        }
    }
    addMultiListener(caller, interests) {
        if (!interests)
            return;
        Object.entries(interests).forEach(([type, listener]) => {
            if (!type || !listener)
                return;
            this.addListener(type, caller, listener);
        });
    }
    removeListener(type, caller, listener) {
        if (!type || listener == null)
            return;
        const all = this._eventDic[type];
        if (!all || !all.length)
            return;
        all.some((item, index) => {
            if (item.compare(caller, listener)) {
                all.splice(index, 1);
                if (all.length === 0) {
                    this._eventDic[type] = null;
                    delete this._eventDic[type];
                }
                return true;
            }
            return false;
        });
    }
    removeMultiListener(caller, interests) {
        if (!interests)
            return;
        Object.entries(interests).forEach(([type, listener]) => {
            if (!type || !listener)
                return;
            this.removeListener(type, caller, listener);
        });
    }
    dispatch(event) {
        if (!event)
            return;
        let all = this._eventDic[event.type];
        if (!all || !all.length)
            return;
        all = all.concat();
        while (all.length) {
            all.shift().runWith(event);
        }
        all.length = 0;
        all = null;
    }
}

/** 游戏的全局代理类 */
class GFacade {
    constructor() {
        this.initEvent();
    }
    /// /////////////////////////////////////// Event
    initEvent() {
        this._innerEventDispatcher = new EventDispatcher();
        this._eventCache = [];
    }
    dispatch(type, data) {
        let evt;
        if (this._eventCache.length) {
            evt = this._eventCache.pop();
            evt.type = type;
            evt.data = data;
        }
        else {
            evt = {
                type,
                data,
            };
        }
        this._innerEventDispatcher.dispatch(evt);
        this._eventCache.push(evt);
    }
    addListener(type, caller, listener) {
        this._innerEventDispatcher.addListener(type, caller, listener);
    }
    addMultiListener(caller, interests) {
        this._innerEventDispatcher.addMultiListener(caller, interests);
    }
    removeListener(type, caller, listener) {
        this._innerEventDispatcher.removeListener(type, caller, listener);
    }
    removeMultiListener(caller, interests) {
        this._innerEventDispatcher.removeMultiListener(caller, interests);
    }
    dispatchEvent(event) {
        this._innerEventDispatcher.dispatch(event);
    }
}
GFacade.inst = new GFacade();

class Notifier {
    constructor() {
        this._facade = GFacade.inst;
        this._events = {};
        this.doReady();
        this._facade.addMultiListener(this, this._events);
    }
    doReady() {
        //
    }
}

const get$1 = (Cls) => {
    let inst;
    if (Object.prototype.hasOwnProperty.call(Cls, '_$inst')) {
        inst = Cls._$inst;
    }
    if (!inst) {
        inst = new Cls();
        Object.defineProperty(Cls, '_$inst', {
            value: inst,
        });
    }
    return inst;
};
const has = (cls) => {
    if (Object.prototype.hasOwnProperty.call(cls, '_$inst')) {
        return cls._$inst;
    }
    return null;
};
const instMap = {};
const registerInst = (name, inst) => {
    if (instMap[name]) {
        throw new Error('重复注册实例');
    }
    instMap[name] = inst;
};
const getRegistedInst = (name) => {
    return instMap[name];
};
const Singleton = {
    get: get$1,
    has,
    registerInst,
    getRegistedInst,
};

const toggle = (viewCls, state = -1, data) => {
    var _a;
    if (!viewCls)
        return null;
    if (state === 0 && !Singleton.get(viewCls))
        return null;
    const viewInst = Singleton.get(viewCls);
    // 切换打开和关闭
    if (state === -1) {
        if (viewInst.isShow) {
            viewInst.hide();
        }
        else {
            viewInst.show(data);
        }
    }
    else if (state === 1) {
        // 打开
        if (viewInst.isShow) {
            (_a = viewInst.bringTop) === null || _a === void 0 ? void 0 : _a.call(viewInst, data);
        }
        else {
            viewInst.show(data);
        }
    }
    else if (state === 0 && viewInst.isShow) {
        // 关闭
        viewInst.hide();
    }
    return viewInst;
};
const register = (viewName, viewCls) => {
    Singleton.registerInst(viewName, viewCls);
};
const toggleByName = (viewName, state = -1, data) => {
    if (!viewName) {
        return null;
    }
    const viewCls = Singleton.getRegistedInst(viewName);
    if (!viewCls)
        return null;
    return toggle(viewCls, state, data);
};
const View = {
    toggle,
    register,
    toggleByName,
};

class BaseDB {
    constructor(rawData, mainKey) {
        this._mainKey = mainKey || 'id';
        this.decode(rawData);
    }
    decode(rawData) {
        if (!rawData || !rawData.length)
            return;
        this._dic = {};
        this._all = [];
        rawData.forEach((item) => {
            const vo = this.createVo(item);
            this._all.push(vo);
            this._dic[vo[this._mainKey]] = vo;
        });
    }
    createVo(data) {
        return data;
    }
    get(mainKey) {
        return this._dic ? this._dic[mainKey] : null;
    }
    getAll() {
        return this._all;
    }
    getDic() {
        return this._dic;
    }
}

/** 单项链表 */
class Chain {
    constructor() {
        this._count = 0;
    }
    createNode(data) {
        if (!Chain._cache.length) {
            return { pre: null, next: null, data };
        }
        const node = Chain._cache.pop();
        node.data = data;
        node.pre = null;
        node.next = null;
        return node;
    }
    removeNode(node) {
        if (!node)
            return;
        if (node.pre) {
            node.pre.next = node.next;
        }
        if (node.next) {
            node.next.pre = node.pre;
        }
        node.pre = null;
        node.next = null;
        node.data = null;
        Chain._cache.push(node);
    }
    removeData(data) {
        let inst = this._first;
        while (inst) {
            if (inst.data === data) {
                this.removeNode(inst);
                break;
            }
            inst = inst.next;
        }
    }
    /** 将数据添加到链表起始位置，并返回链表长度 */
    unshift(data) {
        if (!this._first) {
            return this.push(data);
        }
        const newNode = this.createNode(data);
        this._first.pre = newNode;
        newNode.next = this._first;
        this._first = newNode;
        this._count++;
        return this._count;
    }
    /** 链表尾部追加数据，并返回链表长度 */
    push(data) {
        const newNode = this.createNode(data);
        if (!this._last) {
            this._first = newNode;
            this._last = newNode;
        }
        else {
            this._last.next = newNode;
            newNode.pre = this._last;
            this._last = newNode;
        }
        this._count++;
        return this._count;
    }
    /** 从链表首位删除并返回该数据 */
    shift() {
        if (!this._first)
            return null;
        const { data } = this._first;
        const newFirst = this._first.next;
        this.removeNode(this._first);
        this._first = newFirst;
        if (!newFirst) {
            this._last = null;
        }
        this._count--;
        return data;
    }
    /** 从链表尾部删除并返回数据 */
    pop() {
        if (!this._last)
            return null;
        const { data } = this._last;
        const newLast = this._last.pre;
        this.removeNode(this._last);
        this._last = newLast;
        if (!newLast) {
            this._first = null;
        }
        this._count--;
        return data;
    }
    /** 首位数据 */
    get first() {
        return this._first ? this._first.data : null;
    }
    /** 末尾数据 */
    get last() {
        return this._last ? this._last.data : null;
    }
    /** 链表长度 */
    get count() {
        return this._count;
    }
    some(handler) {
        let inst = this._first;
        if (!inst)
            return false;
        let has = handler(inst.data);
        inst = inst.next;
        while (inst && !has) {
            inst = inst.next;
            has = handler(inst.data);
        }
        return has;
    }
    forEachNode(handler) {
        let inst = this._first;
        while (inst) {
            handler(inst);
            inst = inst.next;
        }
    }
    forEach(handler) {
        let inst = this._first;
        while (inst) {
            handler(inst.data);
            inst = inst.next;
        }
    }
}
Chain._cache = [];

/**
 * 格式化浮点数
 */
const toFloat = (v) => +v || 0;
/**
 * 格式化为整数
 */
const toInt = (v) => ~~v;
/**
 * 格式化为无浮号整数
 */
const toUint = (v) => +v >>> 0;
/**
 * 格式化为字符串
 */
const toString = (v) => (v !== null && v !== void 0 ? v : '');
/**
 * 与原生toFixed不同的是，如果是2.10则会变成2.1; 1.16是1.1而不是1.2
 */
const toFixed = (num, fractionDigits = 0) => {
    const dotIndex = `${num}`.indexOf('.');
    if (dotIndex === -1) {
        return num;
    }
    const fixedNum = `${num}`.substr(0, fractionDigits > 0 ? dotIndex + fractionDigits + 1 : dotIndex);
    return parseFloat(fixedNum);
};
const parseJSON = (v) => {
    const type = typeof v;
    if (type === 'object')
        return v;
    if (type !== 'string')
        return null;
    try {
        return JSON.parse(v);
    }
    catch (e) {
        return null;
    }
};
const twoPWR16DBL = 1 << 16;
const twoPWR32DBL = twoPWR16DBL * twoPWR16DBL;
/** 解析Long数据为number */
const parseLong = (long) => {
    if (!long)
        return 0;
    if (typeof long === 'number')
        return long;
    if (long.unsigned)
        return (long.high >>> 0) * twoPWR32DBL + (long.low >>> 0);
    return long.high * twoPWR32DBL + (long.low >>> 0);
};
const isFunction = (func) => {
    return typeof func === 'function';
};
const isEmpty = (obj) => {
    if (!obj)
        return true;
    return Object.keys(obj).length === 0;
};
const ObjectUtils = {
    toFloat,
    toInt,
    toUint,
    toFixed,
    toString,
    parseJSON,
    parseLong,
    isFunction,
    isEmpty,
};

/** 数值范围模型 */
class Range {
    constructor() {
        this._min = 0;
        this._max = 100;
        this._value = 0;
    }
    onChange(caller, handler, args, once) {
        if (!this._changeHander) {
            this._changeHander = Handler.create(caller, handler, args, once);
        }
        else {
            this._changeHander.setTo(caller, handler, args, once);
        }
    }
    doChange() {
        if (this._changeHander) {
            const hander = this._changeHander;
            if (hander.once) {
                this._changeHander = null;
            }
            hander.run();
        }
    }
    correct() {
        this._value = Math.max(this._min, this._value);
        this._value = Math.min(this._max, this._value);
    }
    setData(v, min, max) {
        this._value = v;
        this._min = min < max ? min : max;
        this._max = min < max ? max : min;
        this.correct();
        this.doChange();
    }
    get min() {
        return this._min;
    }
    set min(v) {
        const fixedValue = ObjectUtils.toFloat(v);
        if (this._min === fixedValue)
            return;
        this._min = fixedValue;
        this.correct();
        this.doChange();
    }
    get max() {
        return this._max;
    }
    set max(v) {
        const fixedValue = ObjectUtils.toFloat(v);
        if (this._max === fixedValue)
            return;
        this._max = fixedValue;
        this.correct();
        this.doChange();
    }
    get value() {
        return this._value;
    }
    set value(v) {
        const fixedValue = ObjectUtils.toFloat(v);
        if (this._value === fixedValue)
            return;
        this._value = fixedValue;
        this.correct();
        this.doChange();
    }
}

/**
 * 解析奖励配置字段
 * @param strRewards 奖励描述文本，如 '10001:1;10002:10'
 * @param itemSplitSymbol 区分道具的间隔字符
 * @param keyvalueSplitSymbol 描述道具数量属性的间隔字符
 */
const decodeReward = (strRewards, itemSplitSymbol = ';', keyvalueSplitSymbol = ':') => {
    if (typeof strRewards !== 'string') {
        return [];
    }
    const result = [];
    const arr = strRewards.split(itemSplitSymbol);
    arr.forEach((item) => {
        if (!item)
            return;
        const arrItem = item.split(keyvalueSplitSymbol);
        if (arrItem.length < 2)
            return;
        result.push({ itemID: arrItem[0], count: ~~arrItem[1] });
    });
    return result;
};

/** 从数组中取随机项 */
const random = (arr) => {
    if (!arr || !arr.length)
        return null;
    return arr[Math.floor(Math.random() * arr.length)];
};
/** 对数组随机排序 */
const sortRandom = (arr) => {
    if (!arr || !arr.length)
        return arr;
    arr.sort(() => (Math.random() > 0.5 ? -1 : 1));
    return arr;
};
const removeItems = (list, ...items) => {
    if (!items.length || !list.length)
        return;
    for (let i = 0, len = list.length; i < len; i++) {
        if (items.length > 0 && items.indexOf(list[i]) !== -1) {
            list.splice(i, 1);
            i -= 1;
            len -= 1;
        }
        else {
            break;
        }
    }
};
const ArrayUtils = {
    random,
    sortRandom,
    removeItems,
};

const rem2px = (n, base = 750) => n * 100 * (document.documentElement.offsetWidth / base);
/**
 * 根据设备DPR，换算成逻辑像素
 */
const dpr2px = (size) => {
    const docFontSize = parseFloat(window.getComputedStyle(document.documentElement, null).getPropertyValue('font-size'));
    return (size / 100) * docFontSize;
};
const scrollTop = (top, smooth = false) => {
    if (smooth && 'scrollBehavior' in document.documentElement.style) {
        try {
            window.scrollTo({
                top,
                behavior: 'smooth',
            });
        }
        catch (e) {
            document.documentElement.scrollTop = top;
            document.body.scrollTop = top;
        }
    }
    else {
        document.documentElement.scrollTop = top;
        document.body.scrollTop = top;
    }
};
const DomUtils = {
    rem2px,
    scrollTop,
    dpr2px,
};

/**
 * cache and use inited value
 */
const initedValue = (valueBuilder, caller) => {
    let isInit = false;
    let value;
    const get = () => {
        if (!isInit) {
            isInit = true;
            value = valueBuilder.call(caller);
        }
        return value;
    };
    const reBuild = () => {
        isInit = true;
        value = valueBuilder.call(caller);
        return value;
    };
    return { get, reBuild };
};

/** 检查浏览器是否支持webP格式 */
const checkWebPSupport = () => {
    var _a;
    try {
        return ((_a = window.supportWebp) !== null && _a !== void 0 ? _a : document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') ===
            0);
    }
    catch (err) {
        return false;
    }
};
const buildIOSVersion = () => {
    const ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('like mac os x') > 0) {
        const reg = /os [\d._]+/gi;
        const versionInfo = ua.match(reg);
        const version = `${versionInfo}`.replace(/[^0-9|_.]/gi, '').replace(/_/gi, '.'); // 得到版本号9.3.2或者9.0
        const arrVersion = version.split('.');
        return { major: ~~arrVersion[0], minor: ~~arrVersion[1], patch: ~~arrVersion[2] };
    }
    return { major: 0, minor: 0, patch: 0 };
};
const buildAndroidVersion = () => {
    const ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('android') > 0) {
        const reg = /android [\d._]+/gi;
        const versionInfo = ua.match(reg);
        const version = `${versionInfo}`.replace(/[^0-9|_.]/gi, '').replace(/_/gi, '.'); // 得到版本号4.2.2
        const arrVersion = version.split('.');
        return { major: ~~arrVersion[0], minor: ~~arrVersion[1], patch: ~~arrVersion[2] };
    }
    return { major: 0, minor: 0, patch: 0 };
};
const Capability = {
    /** 检查是否支持webP */
    getWebPSupport: initedValue(checkWebPSupport).get,
    getIOSVersion: initedValue(buildIOSVersion).get,
    getAndroidVersion: initedValue(buildAndroidVersion).get,
};

const tempDate = new Date();
/**
 * 经过的天数
 * @param from 开始时间戳 秒
 * @param to 当前时间戳 秒
 * @return 如果是同一天则返回0，以此递增
 */
const getOverDays = (from, to) => {
    tempDate.setTime(from * 1000);
    tempDate.setHours(0, 0, 0, 0);
    const fromStamp = tempDate.getTime();
    tempDate.setTime(to * 1000);
    tempDate.setHours(0, 0, 0, 0);
    const toStamp = tempDate.getTime();
    return Math.round((toStamp - fromStamp) / (24 * 3600 * 1000));
};
const DateUtils = {
    getOverDays,
};

class LocalStorage {
    constructor(mainKey, db) {
        this.mainKey = mainKey;
        this._db = db || localStorage;
        this.initialize();
    }
    initialize() {
        try {
            const strData = this._db.getItem(this.mainKey);
            this._data = strData ? JSON.parse(strData) : {};
        }
        catch (e) {
            this._data = {};
        }
    }
    /**
     * TODO ADD CallLater
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    invalidate(now) {
        this._db.setItem(this.mainKey, JSON.stringify(this._data));
    }
    getBool(key) {
        return ObjectUtils.toInt(this._data[key]) === 1;
    }
    setBool(key, v, now) {
        const numV = v ? 1 : 0;
        if (numV === this._data[key])
            return;
        this._data[key] = numV;
        this.invalidate(now);
    }
    getStr(key) {
        var _a;
        return ((_a = this._data[key]) !== null && _a !== void 0 ? _a : '');
    }
    setStr(key, value, now) {
        if (this._data[key] === value)
            return;
        this._data[key] = value;
        this.invalidate(now);
    }
    getNum(key) {
        return ObjectUtils.toFloat(this._data[key]);
    }
    setNum(key, value, now) {
        const formatValue = ObjectUtils.toFloat(value);
        if (this._data[key] === formatValue)
            return;
        this._data[key] = formatValue;
        this.invalidate(now);
    }
    getObj(key) {
        return this._data[key];
    }
    setObj(key, obj, now) {
        this._data[key] = obj;
        if (!obj) {
            delete this._data[key];
        }
        this.invalidate(now);
    }
    clearItem(key) {
        this._data[key] = null;
        delete this._data[key];
        this.invalidate();
    }
    clearAll() {
        this._data = {};
        this._db.removeItem(this.mainKey);
    }
}
LocalStorage.defaultInst = new LocalStorage('$pawgame');

const build = () => {
    if (!window || !window.location)
        return {};
    let s = window.location.search;
    if (!s)
        return {};
    [, s] = s.split('?');
    [s] = s.split('#');
    const dic = {};
    const arrS = s.split('&');
    let arrItem;
    arrS.forEach((item) => {
        if (!item)
            return;
        arrItem = item.split('=');
        const key = arrItem[0];
        dic[key] = arrItem.length > 1 ? arrItem[1] : key;
    });
    return dic;
};
const initedQueryValue = initedValue(build);
const get$2 = (key) => {
    const dic = initedQueryValue.get();
    return dic[key];
};
/** 浏览器地址参数管理 */
const Query = {
    get: get$2,
    getDic: initedQueryValue.get,
    reBuild: initedQueryValue.reBuild,
};

const isQQ = (str) => {
    // 1 首位不能是0  ^[1-9]
    // 2 必须是 [5, 11] 位的数字  \d{4, 9}
    const reg = /^[1-9][0-9]{4,9}$/gim;
    return reg.test(str);
};
// 检查字符串是否为合法手机号码
const isPhone = (str) => {
    const reg = /^(0|86|17951)?(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])[0-9]{8}$/;
    return reg.test(str);
};
const RegExpUtils = {
    isQQ,
    isPhone,
};

/**
 * 设备的安全区域Y
 * @param screenWidth 设备屏幕宽度
 * @param screenHeight 设备屏幕高度
 */
const getSafeY = (screenWidth, screenHeight) => {
    const nowRate = screenHeight / screenWidth;
    const safeRate = 16 / 9;
    return nowRate <= safeRate ? 0 : 0.5 * (screenHeight - screenWidth * safeRate);
};
/**
 * 浏览器全屏时的安全区域Y
 */
const getWebSafeY = () => getSafeY(window.screen.width, window.screen.height);
const DomScreen = {
    getSafeY,
    getWebSafeY,
};

const format = (str, args) => {
    if (!args || !str)
        return str;
    let reg;
    let result = str;
    if (Array.isArray(args)) {
        args.forEach(([item, index]) => {
            reg = new RegExp(`({)${index}(})`, 'g');
            result = result.replace(reg, item);
        });
    }
    else {
        Object.entries(args).forEach(([key, value]) => {
            reg = new RegExp(`({${key}})`, 'g');
            result = result.replace(reg, value);
        });
    }
    return result;
};
const StringUtils = {
    format,
};

const random$1 = (min, max) => min + (max - min) * Math.random();
const randomInt = (min, max) => ~~random$1(min, max);
const MathUtils = {
    random: random$1,
    randomInt,
};

class Signal {
    dispatch(data) {
        if (!this._handerList || !this._handerList.length)
            return;
        const all = this._handerList.concat();
        all.forEach((item) => {
            item.runWith(data);
        });
    }
    on(caller, handler, args, once) {
        if (!this._handerList) {
            this._handerList = [Handler.create(caller, handler, args, once)];
        }
        else {
            const hasPre = this._handerList.some((item) => {
                return item.compare(caller, handler);
            });
            if (!hasPre) {
                this._handerList.push(Handler.create(caller, handler, args, once));
            }
        }
    }
    off(caller, handler) {
        for (let i = 0, len = this._handerList.length; i < len; i++) {
            const itemHandler = this._handerList[i];
            if (itemHandler.compare(caller, handler)) {
                itemHandler.recycle();
                this._handerList.splice(i, 1);
                break;
            }
        }
    }
}

/**
 * CMDRes风格的信号触发器
 */
class CMDResManager {
    constructor() {
        this._cmdSignalDic = {};
    }
    /** 注册 */
    reg(cmd, caller, handler) {
        let cmdSignal = this._cmdSignalDic[cmd];
        if (!cmdSignal) {
            cmdSignal = new Signal();
            this._cmdSignalDic[cmd] = cmdSignal;
        }
        cmdSignal.on(caller, handler, null, false);
    }
    /** 取消注册 */
    unReg(cmd, caller, handler) {
        const cmdSignal = this._cmdSignalDic[cmd];
        if (!cmdSignal)
            return;
        cmdSignal.off(caller, handler);
    }
    /** 执行 */
    route(cmd, code, data) {
        const cmdSignal = this._cmdSignalDic[cmd];
        if (!cmdSignal)
            return;
        cmdSignal.dispatch({ cmd, code, data });
    }
}
CMDResManager.inst = new CMDResManager();

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

const toRequestBody = (body) => {
    if (body === null || body === undefined) {
        return '';
    }
    if (typeof body !== 'object') {
        return body.toString();
    }
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
        return body;
    }
    return JSON.stringify(body);
};
const inferContentType = (body) => {
    if (body === null || body === undefined || typeof body !== 'object') {
        return null;
    }
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
        return null;
    }
    return 'application/json; charset=utf-8';
};
const request = (url, opts) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const { body, headers = {} } = opts;
    const requestInit = Object.assign({}, opts);
    const requestBody = toRequestBody(body);
    if (requestBody) {
        requestInit.body = requestBody;
    }
    const contentType = (_a = headers === null || headers === void 0 ? void 0 : headers['Content-Type']) !== null && _a !== void 0 ? _a : inferContentType(body);
    if (contentType) {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        requestInit.headers = Object.assign(Object.assign({}, headers), { 'Content-Type': contentType });
    }
    return fetch(url, requestInit)
        .then((response) => {
        if (response.status >= 200 && response.status < 300) {
            return response;
        }
        throw response;
    })
        .then((response) => {
        var _a;
        const { headers: replyHeaders } = response;
        const replyContentType = (_a = replyHeaders === null || replyHeaders === void 0 ? void 0 : replyHeaders.get('content-type')) !== null && _a !== void 0 ? _a : '';
        let extractDataPromise;
        if (replyContentType.includes('application/json')) {
            extractDataPromise = response.json();
        }
        else if (replyContentType.includes('text/plain')) {
            extractDataPromise = response.text();
        }
        else if (replyContentType.includes('application/octet-stream')) {
            extractDataPromise = response.blob();
        }
        else if (replyContentType.includes('application/x-www-form-urlencoded')) {
            extractDataPromise = response.formData();
        }
        else {
            // unknown data type
            extractDataPromise = Promise.resolve();
        }
        return extractDataPromise.then((data) => ({
            data,
            headers: replyHeaders,
        }));
    });
});
/**
 * send get request
 * @param url base API path
 * @param params url params for this get request, will be appended to url to make request
 * @param opts other fetch options
 */
const get$3 = (url, params = {}, opts = {}) => {
    return request(appendURLParams(url, params), Object.assign(Object.assign({}, opts), { method: 'GET' }));
};
/**
 * send post request
 * @param url API path
 * @param params body params for this request
 * @param opts other fetch options
 */
const post = (url, params = {}, opts = {}) => {
    return request(url, Object.assign(Object.assign({}, opts), { method: 'POST', body: params }));
};
/**
 * send put request
 * @param url API path
 * @param params body params for this request
 * @param opts other fetch options
 */
const put = (url, params = {}, opts = {}) => {
    return request(url, Object.assign(Object.assign({}, opts), { method: 'PUT', body: params }));
};
/**
 * send delete request
 * @param url base API path
 * @param opts other fetch options
 */
const del = (url, opts = {}) => {
    return request(url, Object.assign(Object.assign({}, opts), { method: 'DELETE' }));
};
const HTTP = {
    get: get$3,
    post,
    put,
    del,
};

export { ArrayUtils, BaseDB, CMDResManager, Capability, Chain, DateUtils, DomScreen, DomUtils, Event, EventDispatcher, GFacade, HTTP, Handler, LocalStorage, MathUtils, Notifier, ObjectPool, ObjectUtils, Query, Range, RegExpUtils, Signal, Singleton, StringUtils, View, decodeReward, format };
